import Vue from 'vue';
import KundeFeldDefinitionService from '@/app/kundefelddefinition/kundefelddefinition.service';
import * as _ from 'lodash';
import abstractStore from '@/store/abstractstore';

export const getDefaultSort = () => ({ currentSort: 'sortOrder', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    bezeichnung: null,
    id: null,
    kundeFelder: [],
    mandant: null,
    printable: false,
    sortOrder: null,
    search: false,
    value: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    ...abstractStore.getAbstractValue(getDefaultSort().currentSort, getDefaultSort().currentSortDir),
});

const kundefelddefinition = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await KundeFeldDefinitionService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await KundeFeldDefinitionService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await KundeFeldDefinitionService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            if ((params && params.params && params.params.init) === true && params.params.page === 0 && context.rootState.belegtext.currentPage !== 0) {
                params.params.page = context.rootState.belegtext.currentPage;
            }
            const { headers, data } = await KundeFeldDefinitionService.query(params);
            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));
            data.forEach((kf) => (kf.value = null));
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await KundeFeldDefinitionService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default _.merge(kundefelddefinition, abstractStore.getDefaultStore());
